import React from "react";

/* Where the reader is, then the two buttons that move them -- the same
   shape .pg-scroll-foot uses under the infinite lists, so a paged tab
   and a scrolling one have the same foot.

   What this replaced was a div with six properties in an inline style
   object, which is the one thing the project's rules forbid outright. */
const Pager = ({ pagination, onPageChange }) => {
  if (!pagination || pagination.totalPages <= 1) return null;
  const { page, totalPages, total } = pagination;

  return (
    <nav className="pg-scroll-foot" aria-label="Pagination">
      <span className="pg-scroll-count">
        Page {page} of {totalPages} · {total} total
      </span>
      <button
        type="button"
        className="pg-btn"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        Previous
      </button>
      <button
        type="button"
        className="pg-btn"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </button>
    </nav>
  );
};

export default Pager;
